<!-- 用 hls 会出现 video 层级遮挡页面问题 -->
<template>
  <div v-if="init" class="player-box" :class="{'player-box-main': main, 'player-box-small': !main }">   
    <!-- 视频 -->
    <div id="videoPlayer" ref="videoPlayer" class="video-player" />

    <div class="video-viewer">
      <van-icon name="fire" />
      <span>{{ room.viewers }}</span>
    </div>

    <!-- 视频封面 -->
    <div v-if="(!videoPlay && !videoRecord) || (!videoLoaded && videoRecord)" class="video-banner">
      <img v-if="room.posterImage" :src="room.posterImage | filterPicture" />
    </div>

    <div @click="clickVideo" :class="{ 'hide': !videoUiVisible }" class="video-ui">
      <van-loading v-if="videoProgressing" class="player-loading-btn" color="#FFF" size="60" />
      <img v-if="!videoPlay" class="player-btn" src="/dg3/static/assets/video-play.png" />
      <div class="top-banner">
        <h4>{{ room.name }}</h4>
      </div>

      <div class="bottom-banner">
        <div @click.stop="pauseVideo" class="video-pause-box">
          <i class="video-pause" />
        </div>
        <div v-if="videoRecord" class="video-progress">
          <van-slider v-model="progressValue" @change="onProgressValueChange" @drag-start="progressLock = true" />
          <p>{{ currentTime | filterProgressTime }} / {{ duration | filterProgressTime }}</p>
        </div>
        <div class="bottom-right">
          <i @click="requestFullscreen" class="video-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TcPlayer from 'TcPlayer'
import { mapState } from 'vuex'

export default {
  props: ['main'],

  data () {
    return {
      init: false,
      player: null,

      videoLoaded: false,  // 是否加载过
      videoPlay: false,
      videoProgressing: false,
      videoRecord: false,  // 是否为回放模式
      videoSource: null,
      videoUiVisible: false,
      videoUiTimer: null,

      // 播放进度条 [videoRecord === true]
      currentTime: 0,
      duration: 0,
      progressValue: 0,
      progressLock: false
    }
  },

  computed: {
    ...mapState({
      room: (state) => state.room,
    })
  },

  filters: {
    filterProgressTime (value) {
      const minutes = parseInt(value / 60).toString()
      const seconds = parseInt(value % 60).toString()

      return minutes.padStart(2, '0') + ':' + seconds.padStart(2, '0')
    },
  },

  watch: {
    'room.status' (val) {
      if (!this.init) this.registerVideo()

      switch (val) {
        case 'DOING':
          this.toast('直播已开始，请点击开始播放~')
          break
        
        case 'STOP':
          this.pauseVideo()
          break

        case 'FINISH':
          this.pauseVideo()
          break
      }
    },

    currentTime (val) {
      this.progressValue = val / this.duration * 100
    }
  },

  methods: {
    registerVideo () {
      this.init = true
      this.videoRecord = this.room.status === 'FINISH' && this.room.liveRecordVideo
      this.videoSource = this.room.status === 'FINISH' ? this.room.liveRecordVideo : this.room.pullStream

      this.$nextTick(() => {
        this.player = new TcPlayer('videoPlayer', {
          m3u8: this.videoSource,
          controls: 'none',
          x5_type: 'h5',
          listener: (message) => {
            switch (message.type) {
              case 'pause':
                this.pauseVideo()
                break

              case 'playing':
                setTimeout(() => { this.videoProgressing = false }, 1000)
                break

              case 'timeupdate':
                this.videoProgressing = false

                if (this.room.status === 'FINISH') {
                  if (!this.duration) this.duration = parseInt(this.player.duration())
                  if (!this.progressLock) this.currentTime = parseInt(this.player.currentTime())
                }
                break
            }
          }
        })
      })
    },

    pauseVideo () {
      this.videoPlay = false
      this.videoProgressing = false
      this.player.pause()

      this.changeVideoUiStatus(false)
    },

    playVideo () {
      if (!this.videoRecord) this.player.load(this.videoSource)
      this.player.play()

      // 视频 waiting 状态需要另外注册, 因为 tcplayer 没有这个事件
      if (!this.videoLoaded) {
        const video = document.querySelector('video')

        video.addEventListener('waiting', (event) => {
          setTimeout(() => { this.videoProgressing = true }, 500)
        })
      }

      this.videoLoaded = true
      this.videoPlay = true

      this.changeVideoUiStatus(false)
    },

    // 点击视频遮罩的操作流程
    // 如果不在直播间则返回直播间
    // 如果视频还未开始 [videoPlay == false] 则需要根据状态进行操作
    // 如果视频已开始则切换 video ui 的显示
    clickVideo () {
      if (this.$route.name !== 'room') {
        if (this.$route.name === 'coupons') {
          this.$router.go(-1)
        } else if (this.$route.name === 'coupon') {
          this.$router.go(-2)
        }

        return
      }

      if (this.videoProgressing) return

      if (this.videoPlay) return this.changeVideoUiStatus()

      if (this.room.status === 'DOING' || this.videoRecord) return this.playVideo()

      let message
      switch (this.room.status) {
        case 'STOP':
          message = '直播暂停中，和大家唠唠嗑吧~'
          break
        case 'FINISH':
          message = '直播已结束，感谢您的观看~'
          break
        case 'READY':
          message = '直播未开始，请耐心等待开播~'
          break
      }

      this.toast(message)
    },

    requestFullscreen () {
      const video = document.querySelector('video')

      video.requestFullscreen
        ? video.requestFullscreen()
        : video.webkitRequestFullscreen
          ? video.webkitRequestFullscreen()
          : video.webkitEnterFullscreen()
    },

    onProgressValueChange (value) {
      this.player.currentTime(this.duration * value / 100)
      this.progressLock = false

      if (!this.videoPlay) this.playVideo()
    },

    changeVideoUiStatus (uiStatus) {
      if (uiStatus === false && this.videoRecord) return
      this.videoUiVisible = (uiStatus !== null && uiStatus !== undefined) ? uiStatus : !this.videoUiVisible

      if (this.videoUiVisible) this.resetVideoUiTimer()
    },

    resetVideoUiTimer () {
      if (this.videoRecord) return

      if (this.videoUiTimer !== null) clearTimeout(this.videoUiTimer)
      this.videoUiTimer = setTimeout(() => this.videoUiVisible = false, 3000)
    },
  }
}
</script>

<style lang="scss" scoped>
.player-box {
  position: fixed;
  z-index: 20;
  display: block;
  width: 100%;
  background-color: #000;
  top: 3.65rem;
  left: 0;
  height: calc(100vw * .5625);
  overflow: hidden;
  .video-viewer {
    position: absolute;
    top: .3rem;
    right: .3rem;
    z-index: 2;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #EEE;
    span {
      margin-left: .05rem;
    }
  }
  .video-player {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .video-banner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #000;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .video-ui {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    overflow: hidden;
    .player-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 46px;
      transform: translate(-50%, -50%);
    }
    .player-loading-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .top-banner {
      display: flex;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 75px;
      background-image: linear-gradient(0deg, transparent 27%, #040404);
      overflow: hidden;
      transition: all .4s;
      padding: 0 4%;
      h4 {
        max-width: 210px;
        padding-bottom: 10px;
        font-size: 14px;
        color: #FFF;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .bottom-banner {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background-image: linear-gradient(-180deg, transparent 27%, #040404);
      transition: all .4s;
      padding: 0 4% 7px;
      .video-pause-box {
        padding: 10px 10px 9px 0;
        .video-pause {
          width: 14px;
          height: 18px;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAYAAACaJFpUAAAAAXNSR0IArs4c6QAAAK1JREFUSA3tl1EKhDAMROt+ePaew8PZY3QTkBF1dAsO7M8EgiGpL/T9tfTe58gauW6Z9VxeRjIir9ytGZ9D1Jf7StBy2TlqDvJm51gFCyl3yk0MPkWw/mjvjvsZBajOeaHKJDhWChWqwkpVJsGxUqhQFVaqMgmOlUKFqrBSlUlwrBQqVIWVqkyC8xelDev3gvX26VjFGC1vuJD/WY8ce2wxxpIPUv40fmT9Ht5xvzjLvxh5axy/AAAAAElFTkSuQmCC);
          background-size: 100% 100%;
        }
      }
      .video-progress {
        display: flex;
        flex: 1;
        height: 34px;
        align-items: center;
        margin: 0 2px 0 8px;
        .van-slider {
          flex: 1;
        }
        p {
          margin-left: 10px;
          font-size: 12px;
          color: #DDD;
        }
      }
      .bottom-right {
        display: flex;
        align-items: flex-end;
        padding-left: 7px;
        .blue-btn {
          padding: 0 12px;
          height: 24px;
          margin: 0 20px 6px 0;
          line-height: 22px;
          font-size: 12px;
          color: #f7f7f7;
          text-align: center;
          border-radius: 22px;
          border: 1.5px solid #fff;
        }
        .video-full {
          margin-bottom: 6px;
          width: 24px;
          height: 24px;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdxJREFUaAXtmLtOwzAUhhsQCBYGJph4ByYegMtD8A7MsLCyIYFY2FgqwUOws7CyZuG2IoYWKlS+g1rJan3sBjlxDD7S36S2c/z9x4mautPJkSuQK5Ar8G8qMBwOt9ALqhL3DF7VijSnddTUvk/etYq5Nxm/p13TtIEuIK8ajKN9Uetr1EBRFHdoHVkDyHMNVGtv1IAGIe3c52ccDowxA+NcPW2FAQv8DcQib0Q3oMDLw/7lpWdAVAMaPA/ITPBiMJqBEPDRDISCj2IgJHzjBkLDN2rgF/AfAjiKz/FJlKPAIzOu+TLvgqFfXvyekfNlzpUjSB8Ax8gML3yQiUMlgfzJoE8LXooAvKzAG7pAztsmVNGC5wG8CJ40J/xrFeA22UYP6BYtJeUP4F3UQ+PYScYAxJPwJW3xVoDJj9AjOvRVkTE2+A3fdbX2A9VHEn3XRPS3D16Af9BHH5qB1sLPYqDV8D4DrYd3GUgCXjOQDLzNQFLwkwaSg7cYMF8PSgzF/ZESQF8AaYuSxlbCT/3REHqLSdkhMHcJzCGyY3DKduCJ2djUuc2AAC1UBHjHwErFa4IMt+2NXpLZtgrahDL2Suusu31qBWRC7qJlDrOuwoDq9+oGzflzBXIF7BX4Bi7riO5f7jKHAAAAAElFTkSuQmCC);
          background-size: 100% 100%;
        }
      }
    }
    i {
      display: block;
    }
  }
  .video-ui.hide {
    .top-banner {
      transform: translateY(-100%);
    }
    .bottom-banner {
      transform: translateY(100%);
    }
  }
}
</style>

<style lang="scss">
.player-box {
  transition: all 400ms;
  video {
    transition: all 400ms;
  }
}

.player-box.player-box-small {
  top: calc(100vh - 3.5rem * .5625 - .4rem);
  left: 2rem;
  width: 3.5rem;
  height: calc(3.5rem * .5625);
  border-radius: .16rem;
  border: 1px solid #FFF;
  overflow: hidden;
  .vcp-player, video { 
    width: 3.5rem !important;
    height: calc(3.5rem * .5625) !important;
  }
}
</style>
